module.exports = __webpack_public_path__ + "ec77d856b2ac7bd115f9d81dde8887e5.svg";